import * as actionTypes from "./actionTypes";
// import { orders } from "../../data";
import { firebase } from "../../firebase/index";
import { collections, constants } from "../../firebase/firestoreNameSpaces";
import { getShipment } from "../utility";

const combineStatus = (StatusType, Status) => {
  StatusType = StatusType;
  Status = Status;
  let StatusCombination = [];
  for (let i = 0; i < StatusType.length; i++) {
    let stype = StatusType[i];

    for (let j = 0; j < Status.length; j++) {
      let st = Status[j];
      StatusCombination.push(`${stype}_${st}`);
    }
  }

  return StatusCombination;
};

export const resetLoadMore = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { leadsexhausted: false, lastDoc: null },
    });
  };
};
export const onFetchOngoingOrders = () => {
  return (dispatch) => {
    return null;
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { ongoingOrdersLoading: true },
    });

    let db = firebase.firestore();
    var unsubscribe = db
      .collection(collections.ORDERS)
      .where("paymentStatus", "in", ["confirmed", "cod"])
      .where("orderStatus", "==", "created")
      .where("orderType", "!=", "scheduled")
      .onSnapshot(
        (snapshot) => {
          let fetchedorders = [];
          snapshot.forEach((order) => {
            fetchedorders.push(order.data());
          });
          //  let unsubs = {...getState().orders.unsubscribe}
          //  unsubs["onFetchOngoingOrders"] = function(){
          //    unsubscribe()
          //  };
          fetchedorders
            .sort((a, b) =>
              a.orderDate
                .toString()
                .localeCompare(b.orderDate.toString(), "en", { numeric: true })
            )
            .reverse();

          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              ongoingOrdersLoading: false,
              ongoingOrders: fetchedorders,
            },
          });
        },
        (err) => {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: { ongoingOrdersLoading: false, ongoingOrders: [] },
          });
          if (!localStorage.getItem("idToken")) {
            return true;
          }
          console.log(err);
          return alert(err);
        }
      );
  };
};

export const onFetchAcceptedOrders = () => {
  return (dispatch) => {
    return null;
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { acceptedOrdersLoading: true },
    });

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("paymentStatus", "in", ["confirmed", "cod"])
      .where("orderStatus", "==", "accepted")
      .where("orderType", "!=", "scheduled")
      .onSnapshot(
        (snapshot) => {
          let fetchedorders = [];
          snapshot.forEach((order) => {
            fetchedorders.push(order.data());
          });
          fetchedorders
            .sort((a, b) =>
              a.orderDate
                .toString()
                .localeCompare(b.orderDate.toString(), "en", { numeric: true })
            )
            .reverse();
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              acceptedOrdersLoading: false,
              acceptedOrders: fetchedorders,
            },
          });
        },
        (err) => {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              acceptedOrdersLoading: false,
              acceptedOrders: [],
            },
          });
          if (!localStorage.getItem("idToken")) {
            return true;
          }
          return alert(err);
        }
      );
  };
};

const getFilteredOrderProducts = (orders, StatusCombination) => {
  return new Promise(async (resolve, reject) => {
    // console.log(orders)
    let filteredOrders = [];
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];
      let filteredProducts = [];
      let products = order.products;
      for (let j = 0; j < products.length; j++) {
        let product = products[j];
        let { Status, StatusType } = await getShipment(product, order);
        // console.log(StatusCombination,`${StatusType}_${Status}`)
        if (StatusCombination.includes(`${StatusType}_${Status}`)) {
          filteredProducts.push(product);
        }
      }
      order.products = filteredProducts;
      filteredOrders.push(order);
    }

    resolve(filteredOrders);
  });
};
//Using as Forward Orders.
export const onFetchCompletedOrders = (sc) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { completedOrdersLoading: true },
    });
    let forwardsc = constants.FORWARD_SHIPMENT.STATUS_COMBINATION;
    let StatusCombination = sc ? sc : forwardsc[Object.keys(forwardsc)[0]];
    let limit = getState().orders.limit;

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("paymentStatus", "==", "confirmed")
      .where(
        "orderStatus.StatusCombination",
        "array-contains-any",
        StatusCombination
      )
      .orderBy("timestamp", "desc")
      .limit(limit)
      .get()
      .then(async (snapshot) => {
        let fetchedorders = [];
        let lastDoc = snapshot.docs[snapshot.size - 1];
        snapshot.forEach((order) => {
          fetchedorders.push(order.data());
        });

        fetchedorders = await getFilteredOrderProducts(
          fetchedorders,
          StatusCombination
        );

        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              completedOrdersLoading: false,
              completedOrders: fetchedorders,
              lastDoc: lastDoc,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              completedOrdersLoading: false,
              completedOrders: fetchedorders,
              lastDoc: lastDoc,
            },
          });
        }
        // dispatch({
        //   type: actionTypes.ORDERS_CONTROLS,
        //   payload: {
        //     completedOrdersLoading: false,
        //     completedOrders: fetchedorders,
        //   },
        // });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: {
            completedOrdersLoading: false,
            completedOrders: [],
          },
        });
        console.log(err);
        return alert(err);
      });
  };
};

export const onLoadMoreCompletedOrders = (
  leadsexhausted,
  lastDoc,
  limit,
  sc
) => {
  return (dispatch, getState) => {
    if (leadsexhausted) {
      // return alert("Leads Exhausted");
      return true;
    }
    console.log(sc);
    let forwardsc = constants.FORWARD_SHIPMENT.STATUS_COMBINATION;
    let StatusCombination = sc ? sc : forwardsc[Object.keys(forwardsc)[0]];
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .where("paymentStatus", "==", "confirmed")
      .where(
        "orderStatus.StatusCombination",
        "array-contains-any",
        StatusCombination
      )
      .orderBy("timestamp", "desc")
      .startAfter(lastDoc)
      .limit(limit)
      .get()
      .then(async (snapshot) => {
        let fetchedOrders = getState().orders.completedOrders;
        snapshot.forEach((order) => {
          fetchedOrders.push(order.data());
        });

        fetchedOrders = await getFilteredOrderProducts(
          fetchedOrders,
          StatusCombination
        );
        lastDoc = snapshot.docs[snapshot.size - 1];
        if (snapshot.size) {
          if (snapshot.size < limit) {
            dispatch({
              type: actionTypes.ORDERS_CONTROLS,
              payload: {
                completedOrdersLoading: false,
                completedOrders: fetchedOrders,
                lastDoc: lastDoc,
                leadsexhausted: true,
              },
            });
          } else {
            dispatch({
              type: actionTypes.ORDERS_CONTROLS,
              payload: {
                completedOrdersLoading: false,
                lastDoc: lastDoc,
                completedOrders: fetchedOrders,
              },
            });
          }
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              completedOrdersLoading: false,
              leadsexhausted: true,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: {
            completedOrdersLoading: false,
            // completedOrders: [],
          },
        });
        return alert(err);
      });
  };
};

//Using as Reverse Orders.
export const onFetchCancelledOrders = (sc) => {
  return (dispatch, getState) => {
    let backwardsc = constants.BACKWARD_SHIPMENT.STATUS_COMBINATION;
    let StatusCombination = sc ? sc : backwardsc[Object.keys(backwardsc)[0]];
    // console.log(StatusCombination)
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { cancelledOrdersLoading: true },
    });
    let limit = getState().orders.limit;
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      // .where("paymentStatus", "in", ["confirmed", "cod"])

      .where("paymentStatus", "==", "confirmed")
      .where(
        "orderStatus.StatusCombination",
        "array-contains-any",
        StatusCombination
      )
      .orderBy("timestamp", "desc")
      .limit(limit)
      .get()
      .then(async (snapshot) => {
        let fetchedOrders = [];
        let lastDoc = snapshot.docs[snapshot.size - 1];
        snapshot.forEach((order) => {
          let data = order.data();

          fetchedOrders.push(data);
        });
        fetchedOrders = await getFilteredOrderProducts(
          fetchedOrders,
          StatusCombination
        );
        if (snapshot.size < limit) {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              cancelledOrdersLoading: false,
              cancelledOrders: fetchedOrders,
              lastDoc: lastDoc,
              leadsexhausted: true,
            },
          });
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              cancelledOrdersLoading: false,
              cancelledOrders: fetchedOrders,
              lastDoc: lastDoc,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: {
            cancelledOrdersLoading: false,
            cancelledOrders: [],
          },
        });
        console.log(err);
        return alert(err);
      });
  };
};

export const onLoadCancelledOrders = (leadsexhausted, lastDoc, limit, sc) => {
  return (dispatch, getState) => {
    if (leadsexhausted) {
      // return alert("Leads Exhausted");
      return true;
    }
    let backwardsc = constants.BACKWARD_SHIPMENT.STATUS_COMBINATION;
    let StatusCombination = sc ? sc : backwardsc[Object.keys(backwardsc)[0]];
    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      // .where("paymentStatus", "in", ["confirmed", "cod"])
      .where("paymentStatus", "==", "confirmed")
      .where(
        "orderStatus.StatusCombination",
        "array-contains-any",
        StatusCombination
      )
      .orderBy("timestamp", "desc")
      .startAfter(lastDoc)
      .limit(limit)
      .get()
      .then(async (snapshot) => {
        let fetchedOrders = getState().orders.cancelledOrders;
        snapshot.forEach((order) => {
          let data = order.data();

          fetchedOrders.push(data);
        });
        fetchedOrders = await getFilteredOrderProducts(
          fetchedOrders,
          StatusCombination
        );
        lastDoc = snapshot.docs[snapshot.size - 1];
        if (snapshot.size) {
          if (snapshot.size < limit) {
            dispatch({
              type: actionTypes.ORDERS_CONTROLS,
              payload: {
                cancelledOrdersLoading: false,
                cancelledOrders: fetchedOrders,
                lastDoc: lastDoc,
                leadsexhausted: true,
              },
            });
          } else {
            dispatch({
              type: actionTypes.ORDERS_CONTROLS,
              payload: {
                cancelledOrdersLoading: false,
                lastDoc: lastDoc,
                cancelledOrders: fetchedOrders,
              },
            });
          }
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              cancelledOrdersLoading: false,
              leadsexhausted: true,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: {
            cancelledOrdersLoading: false,
            // completedOrders: [],
          },
        });
        return alert(err);
      });
  };
};

export const onFetchScheduledOrders = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { scheduledOrdersLoading: true },
    });

    let db = firebase.firestore();

    db.collection(collections.ORDERS)
      // .where("paymentStatus", "in", ["confirmed", "cod"])
      .where("orderStatus", "in", ["created", "accepted"])

      .where("orderType", "==", "scheduled")
      .onSnapshot(
        (snapshot) => {
          let fetchedorders = [];
          snapshot.forEach((order) => {
            let data = order.data();
            if (
              data.paymentStatus == "confirmed" ||
              data.paymentStatus == "cod"
            ) {
              fetchedorders.push(data);
            }
          });
          fetchedorders
            .sort((a, b) =>
              a.orderDate
                .toString()
                .localeCompare(b.orderDate.toString(), "en", { numeric: true })
            )
            .reverse();
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              scheduledOrdersLoading: false,
              scheduledOrders: fetchedorders,
            },
          });
        },
        (err) => {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              scheduledOrdersLoading: false,
              scheduledOrders: [],
            },
          });
          if (!localStorage.getItem("idToken")) {
            return true;
          }
          return alert(err);
        }
      );
  };
};
export const onClickDoneOrder = (order) => {
  return (dispatch) => {
    let professional = {};
    professional["professionalAccount"] = order.professionalAccount;
    professional["professionalContact"] = order.professionalContact;
    professional["professionalIfsc"] = order.professionalIfsc;
    professional["professionalName"] = order.professionalName;
    let orderId = order.receipt;

    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { doneOrderBtnLoading: true },
    });

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .doc(orderId)
      .update({
        orderStatus: "completed",
        completionTimestamp: firebase.firestore.Timestamp.now().seconds * 1000,
        professional: professional,
      })
      .then(() => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { doneOrderBtnLoading: false },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { doneOrderBtnLoading: false },
        });
        return alert(err);
      });
  };
};

export const onClickCancelOrder = (order) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { cancelOrderBtnLoading: true },
    });

    // let db = firebase.firestore();
    // db.collection(collections.ORDERS)
    //   .doc(orderId)
    //   .update({
    //     orderStatus: "cancelled",
    //   })
    firebase
      .functions()
      .httpsCallable("cancelOrder")(order)
      .then(() => {
        document.getElementById("adminOrderCancel" + order.receipt).click();
        let orders = getState().orders.scheduledOrders;
        orders.filter((orderobj) => orderobj.receipt != order.receipt);
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { cancelOrderBtnLoading: false, scheduledOrders: orders },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { cancelOrderBtnLoading: false },
        });
        alert(err);
      });
  };
};

export const onClickPayProfessional = (orderId) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { professionalPaymentLoading: true },
    });

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .doc(orderId)
      .update({
        professionalPaymentStatus: "done",
      })
      .then(() => {
        let orders = getState().orders.completedOrders;
        let order = orders.filter((orderobj) => orderobj.receipt == orderId)[0];
        if (order) {
          order["professionalPaymentStatus"] = "done";
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: {
              professionalPaymentLoading: false,
              completedOrders: orders,
            },
          });
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: { professionalPaymentLoading: false },
          });
          window.location.reload();
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { professionalPaymentLoading: false },
        });
        return alert(err);
      });
  };
};
export const onClickRefund = (receipt, waybill) => {
  return (dispatch, getState) => {
    let orders = getState().orders.cancelledOrders;

    dispatch({
      type: actionTypes.ORDERS_CONTROLS,
      payload: { refundBtnLoading: true },
    });

    let db = firebase.firestore();
    db.collection(collections.ORDERS)
      .doc(receipt)
      .set(
        {
          packageStatus: {
            [waybill]: { isRefunded: true },
          },
        },
        { merge: true }
      )
      .then(() => {
        let order = orders.filter((orderObj) => orderObj.receipt == receipt)[0];
        if (order) {
          let packageStatus = order.packageStatus;
          packageStatus[waybill] = { ...packageStatus, isRefunded: true };
          order["packageStatus"] = packageStatus;

          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: { refundBtnLoading: false, cancelledOrders: orders },
          });
        } else {
          dispatch({
            type: actionTypes.ORDERS_CONTROLS,
            payload: { refundBtnLoading: false, cancelledOrders: orders },
          });
          window.location.reload();
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ORDERS_CONTROLS,
          payload: { refundBtnLoading: false },
        });
        return alert(err);
      });
  };
};
